import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import type { Option } from '@ds/components/InputSelect'

import { useMetadata } from '../../../composables/useMetadata'
import { VALUE_ALL } from '../Filters.constants'

import translations from './useOptions.translations'

export function useOptions() {
  const i18n = useI18n()
  const optionAll = { label: i18n(translations.all), value: VALUE_ALL }
  const { metadata } = useMetadata()

  const marketOptions = computed<Option[]>(() => [
    optionAll,
    ...metadata.value.filterMarket.map(({ label, code }) => ({
      label,
      value: code,
    })),
  ])
  const categoryOptions = computed<Option[]>(() => [
    optionAll,
    ...metadata.value.filterCategory.map(({ label, id }) => ({
      label,
      value: id.toString(),
    })),
  ])

  return {
    marketOptions,
    categoryOptions,
  }
}
